<template>
    <div>
<!--        <b-spinner label="Loading..."></b-spinner>-->

            <div class="divCenter">
            <h4 class="mb-3">EANs Verwalten</h4>
            <form>
                <p class="mt-2 lead">Verfügbare EANs:

                <abbr title="HyperText Markup Language" @click="$bvModal.show('modal-xl')">{{eanList.length}}</abbr>
                </p>

                    <b-modal id="modal-xl" size="xl"  v-bind:title="'Einträge vorhanden: ' + eanList.length">
                    <b-list-group>
                        <b-list-group-item v-for="(item) in eanList" :key="item">{{item}}</b-list-group-item>
                    </b-list-group>
                </b-modal>



                <h4 class="mt-3">EANs hinzufügen</h4>
                <div class="input-group ">
                    <input type="text" class="form-control" v-model="eanAdd">
                    <div class="input-group-append">
                        <b-button class="btn btn-outline-light" type="button" @click="addOneEAN">EAN manuell hochladen</b-button>
                    </div>
                </div>

                <h5 class="mt-2 mb-2">oder</h5>


                <div class="">
                    <b-form-file
                            v-model="file1"
                            :state="Boolean(file1)"
                            placeholder="EANs hochladen (.xlsx .csv)"
                            @change="fileUploaded"
                            drop-placeholder="Drop file here..."
                    ></b-form-file>
                    <span id="button-1">
                        <b-button id="btn-upload-disabled" v-if="!fileJSON || fileJSON.length == 0" class="btn mt-1" disabled>EANs hochladen</b-button>
                    </span>
                    <b-button v-if="fileJSON && fileJSON.length != 0" class="btn mt-1 btn-outline-light" type="button" @click="uploadEANs">{{this.fileJSON.length}} EANs hochladen</b-button>
                    <b-tooltip target="button-1" title="Bitte Datei auswählen"></b-tooltip>
                </div>
            </form>
        </div>
    </div>


</template>


<script>

    import XLSX from 'xlsx'
    import Api from './api'

    export default {

        data() {
            return {
                materials: [],
                file1: null,
                fileJSON: [],
                shippingOptions: [],
                selectedMaterialTxt: "",
                selectedMaterial: {},
                selectedShippingOption: "",
                parentSKU: "",
                itemLines: undefined,
                isDemo: false,
                eanList : [],
                eanAdd: ''
            }
        },
        methods: {

            makeToast(variant = null, body = '', title = '') {
                this.$bvToast.toast(body, {
                    title: title,
                    variant: variant,
                    solid: true
                })
            },

            addOneEAN(){
              if(this.eanAdd && this.eanAdd.length >5){
                  console.log([this.eanAdd])

                  Api.ean.addEAN([this.eanAdd])
                      .then(result => {
                          if(result.status === 200){
                              this.makeToast('success', 'EAN ' + this.eanAdd + " wurde erfolgreich hinzugefügt", 'Erfolgreich')
                              this.eanAdd = ''
                              this.calculateEANs()
                          }
                          else {
                              this.makeToast('danger', 'EAN ' + this.eanAdd + " konnte nicht hinzugefügt werden", 'Fehler')
                              // this.eanAdd = ''
                          }
                      })
                      .catch(e => {
                          this.makeToast('danger', 'EAN ' + this.eanAdd + " konnte nicht hinzugefügt werden. Fehler: " + e.message, 'Fehler')

                      })
              }else {
                  this.makeToast('warning', 'EAN ' + this.eanAdd + " ist zu kurz (min. 5 Zeichen erforderlich).", 'Warnung')

              }
            },

            uploadEANs(){
                if(this.fileJSON){
                    Api.ean.addEAN(this.fileJSON)
                        .then(result => {
                            if(result.status === 200){
                                this.makeToast('success',this.fileJSON.length + "Datensätze wurden erfolgreich hinzugefügt", 'Erfolgreich')
                                this.file1 = ''
                                this.calculateEANs()
                            }
                            else {
                                this.makeToast('danger', "EANs konnten nicht hinzugefügt werden", 'Fehler')
                                // this.eanAdd = ''
                            }
                        })
                        .catch(e => {
                            this.makeToast('danger', "EANs konnten nicht hinzugefügt werden. \n Fehler: " + e.message, 'Fehler')

                        })
                }else {
                    this.makeToast('warning', 'EAN Liste hat ' + this.eanAdd + " Einträge", 'Warnung')

                }
            },



            calculateEANs(){
                Api.ean.countEANs()
                    .then(data => data.data)
                    .then(data => {
                        this.eanList = data
                    })
                    .catch((e) => {
                        this.eanList = []
                        this.makeToast("danger", e.message ? e.message : "Fehler", "Fehler beim EAN Abruf")
                    })
            },

            fileUploaded(e) {
                try {


                    let file = e.currentTarget.files ? e.currentTarget.files[0] : e.dataTransfer.files[0];
                    if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls") && !file.name.endsWith(".xlsm") && !file.name.endsWith(".csv")) {
                        throw new Error("Falsches format! Erwartet: .xlsx .xls .xlsm .csv")
                    }

                    let reader = new FileReader();
                    const that = this;
                    reader.addEventListener("load", e => {
                        try {


                        // let items = []
                        let workbook = XLSX.read(e.target.result, {type: 'binary'})
                        workbook.SheetNames.forEach(function (sheetName) {
                            console.log(XLSX.utils)

                            let unfilteredList = XLSX.utils.sheet_to_csv(workbook.Sheets[sheetName])
                            that.fileJSON =  unfilteredList.split('\n').filter(n => n.length != 0)

                            console.log(that.fileJSON)
                            that.makeToast('success', "Datei erfolgreich gelesen.\n" + that.fileJSON.length + " Einträge vorhanden", "Erfolgreich gelesen")
                        })
                        }catch (e) {
                            this.makeToast('danger', e.message ? e.message : "Fehler", "Fehler beim Lesen")
                        }
                    });
                    reader.readAsBinaryString(file)
                } catch (e) {
                    this.makeToast('danger', e.message ? e.message : "Fehler", "Fehler beim Lesen")
                }
            }
        },

        beforeMount() {
            console.warn("Before mount")
            let jwt = this.$cookies.get("authToken")
            // console.log(jwt)
            Api.auth.verify({authToken: jwt})
                .then(response => {
                    if (response.status == 200) {
                        this.$store.commit('setUser', true)
                        Api.init(jwt)
                        this.calculateEANs()
                    }
                })
                .catch(() => {
                    this.$store.commit('setUser', false)
                    this.$router.push({path: '/'})
                })
        }

    }
</script>

<style>
    .hl-dropdown {
        width: 200px;
    }

    .divCenter {
        padding-top: 20px;
        margin-left: 30%;
        margin-right: 30%;
    }


    .table-condensed {
        font-size: 12px;
    }

    .mt-10 {
        margin-top: 3%;
    }

</style>
